// Facebook Pixel tracking utilities

// Check if Facebook Pixel is loaded
export const isFacebookPixelLoaded = () => {
  return typeof window !== 'undefined' && window.fbq;
};

// Track page view (this is automatically called by the base code, but you can use it for SPA navigation)
export const trackPageView = () => {
  if (isFacebookPixelLoaded()) {
    window.fbq('track', 'PageView');
  }
};

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  if (isFacebookPixelLoaded()) {
    window.fbq('track', eventName, parameters);
  }
};

// Standard Facebook Pixel events
export const trackLead = (parameters = {}) => {
  trackEvent('Lead', parameters);
};

export const trackCompleteRegistration = (parameters = {}) => {
  trackEvent('CompleteRegistration', parameters);
};

export const trackContact = (parameters = {}) => {
  trackEvent('Contact', parameters);
};

export const trackSearch = (parameters = {}) => {
  trackEvent('Search', parameters);
};

export const trackViewContent = (parameters = {}) => {
  trackEvent('ViewContent', parameters);
};

export const trackSubmitApplication = (parameters = {}) => {
  trackEvent('SubmitApplication', parameters);
};

// Custom events for your university application site
export const trackUniversitySearch = (searchTerm, filters = {}) => {
  trackEvent('Search', {
    search_string: searchTerm,
    content_category: 'university',
    ...filters
  });
};

export const trackCourseView = (courseName, university) => {
  trackEvent('ViewContent', {
    content_name: courseName,
    content_category: 'course',
    content_ids: [courseName],
    custom_data: {
      university: university
    }
  });
};

export const trackApplicationSubmit = (university, course, applicationData = {}) => {
  trackEvent('SubmitApplication', {
    content_name: course,
    content_category: 'application',
    custom_data: {
      university: university,
      course: course,
      ...applicationData
    }
  });
};

export const trackFormSubmit = (formType, formData = {}) => {
  const eventMap = {
    'contact': 'Contact',
    'application': 'SubmitApplication',
    'newsletter': 'CompleteRegistration',
    'inquiry': 'Lead'
  };
  
  const eventName = eventMap[formType] || 'Lead';
  trackEvent(eventName, {
    content_category: formType,
    custom_data: formData
  });
};

export const trackNewsView = (newsTitle, newsCategory) => {
  trackEvent('ViewContent', {
    content_name: newsTitle,
    content_category: 'news',
    content_type: newsCategory
  });
};

export const trackScholarshipView = (scholarshipName) => {
  trackEvent('ViewContent', {
    content_name: scholarshipName,
    content_category: 'scholarship'
  });
};

// Track phone calls or email clicks
export const trackContactAction = (actionType, contactInfo) => {
  trackEvent('Contact', {
    content_category: actionType, // 'phone' or 'email'
    custom_data: {
      contact_method: actionType,
      contact_info: contactInfo
    }
  });
};
